import { inferAdditionalFields, organizationClient, twoFactorClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

// Same origin as the API (/api/auth); the session is an httpOnly __Host- cookie.
export const authClient = createAuthClient({
  basePath: '/api/auth',
  plugins: [
    organizationClient(),
    twoFactorClient(),
    inferAdditionalFields({ user: { locale: { type: 'string', required: false } } }),
  ],
});
